import { api } from '@cma/app'
import {
  AdminRosterQuery,
  AdminRosterQueryVariables
} from '@cma/generated/graphql'
import { useQuery } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useAdminRoster(variables: AdminRosterQueryVariables) {
  return useQuery<AdminRosterQuery, Error>(
    ['adminRoster', variables],
    () => {
      const query = gql`
        fragment AdminAgentRosterParts on User {
          id
          guid
          casUserId
          avatar
          name
          email
          city
          state
          status
          casJwt
          lwaJwt
          platformRole
          recentReport {
            __typename
            guid
            title
            updatedAt
            pdfPermalink
          }
          lastSignInAt
        }

        query AdminRoster(
          $id: ID!
          $brokerageId: ID
          $officeId: ID
          $value: String
          $after: String
          $before: String
          $first: Int
          $last: Int
        ) {
          platformClient(id: $id) {
            agents(
              after: $after
              before: $before
              first: $first
              last: $last
              brokerageId: $brokerageId
              officeId: $officeId
              value: $value
            ) {
              total
              pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
              }
              edges {
                node {
                  ...AdminAgentRosterParts
                }
              }
            }
          }
        }
      `
      return api<AdminRosterQuery, AdminRosterQueryVariables>({
        query,
        variables
      })
    },
    {
      enabled: !!variables.id
    }
  )
}
